import React from 'react'
import { getImages } from '../../Componments/Frontend/const'
import ContactForm from '../../Componments/Frontend/OurTeam/ContactForm'

const OurTeams = () => {
  return (
    <>
        <section className='our-team-wrap'>
            <section className='fullh-hero-wrap hero-shadow position-relative' 
                style={{
                    backgroundImage: `url(${getImages('our-team-hero.webp')})`
                }}
            >
                <div className='banner-pos'>
                    <div className='banner-title wow fadeInUp' data-wow-duration="1s" data-wow-delay="0.5s">
                        <span className='text-orange'>Presidential Team</span> <br/>Experience Excellence
                    </div>
                </div>
            </section>
            <section className='founded-wrap'>
                <div className='container'>
                    <div className='our-team-box mb-70'>
                        <div className='row align-items-center'>
                            <div className='col-lg-6 order-2 ps-lg-5'>
                                <div className='otb-img'>
                                    <img src={getImages('funded.webp')} alt='funded'/>
                                </div>
                            </div>
                            <div className='col-lg-6 pe-lg-4'>
                                <div className='lg-title mb-2 font-bold'>Founded on Hustle</div>
                                <div className='ssm-content mb-3'>
                                    <p>38 Years in this business is no small feat. We’ve seen many come and go, but we believe our family has stood the test of time by placing the value where it belongs, in our life-long customers.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='xlg-title mb-2 font-bold text-center text-white pb-2'>Experience <span className='text-orange'>Excellence</span> like <br/>never before</div>
                    <div className='our-team-box mt-5'>
                        <div className='row align-items-center'>
                            <div className='col-lg-6 order-2 ps-lg-5'>
                                <div className='otb-img'>
                                    <img src={getImages('about.webp')} alt='funded'/>
                                </div>
                            </div>
                            <div className='col-lg-6 pe-lg-4'>
                                <div className='lg-title mb-2 font-bold'>What we’re About</div>
                                <div className='ssm-content mb-3'>
                                    <p>Founded in 1986 we’ve put in decades of sweat to give our customers a car buying experience like no other. We believe in delivering value and a car driving experience that will inspire your passions for years to come.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='otm-contant-wrap'>
                <div className='container'>
                    <div className='ssm-content'>
                        <p>At Presidential Auto Sales, Service, and Leasing, our mission is simple: to treat every customer with the same respect and care we would want for ourselves. We believe that the car-buying experience should be enjoyable and stress-free, fostering lasting relationships with our clients—many of whom have become cherished friends over the years.</p>

                        <p>Nestled in the vibrant heart of South Florida's "Gold Coast," between Fort Lauderdale and Palm Beach, our family-owned dealership has proudly served the community since 1986. We offer a wide selection of luxury new and pre-owned vehicles, all in one convenient location in Delray Beach.</p>

                        <p>As authorized agents for leading national banks and leasing companies, we leverage cutting-edge technology to find you the best financing options available. Our commitment to competitive pricing and transparency ensures that you receive the best deal possible, complete with all manufacturer rebates, incentives, and special financing rates.</p>
                    </div>
                </div>
            </section>
            <section className='drop-us-wrap'>
                <div className='container'>
                    <div className='our-team-box'>
                        <div className='lg-title font-bold text-center'>Drop Us a Line</div>
                        <div className='sm-title text-center'><em>Call or Text us at (561) 266-000</em></div>
                        <ContactForm />
                    </div>
                </div>
            </section>
        </section>
    </>
  )
}

export default OurTeams